import { SalaryComponent } from 'components/SalaryComponents/types';
import { SalaryStructureComponent } from 'components/SalaryStructure/types';
import { ValidationSchema } from 'forms';
import { SalaryStructureFormData } from './types';

/**
 * Converts a salary component from API to structure component format
 */
export const convertToStructureComponent = (
  component: SalaryComponent,
): SalaryStructureComponent => {
  return {
    id: component.id,
    salaryComponent: component,
    valueType: 'SALARY_STRUCTURE_COMPONENT_VALUE_TYPE_CTC',
    salaryComponentId: component.id,
  };
};

export const basicDetailsStepValidationSchema: ValidationSchema<SalaryStructureFormData> = {
  name: (formData) => {
    if (!formData.name) {
      return 'Name is required';
    }
    return null;
  },
  description: (formData) => {
    if (!formData.description) {
      return 'Description is required';
    }
    return null;
  },
  templateId: (formData) => {
    if (
      formData.creationType &&
      formData.creationType === 'from-existing' &&
      !formData.templateId
    ) {
      return 'Please select a template';
    }
    return null;
  },
};

export const structureDetailsStepValidationSchema: ValidationSchema<SalaryStructureFormData> = {
  name: (formData) => {
    if (!formData.name) {
      return 'Name is required';
    }
    return null;
  },
  description: (formData) => {
    if (!formData.description) {
      return 'Description is required';
    }
    return null;
  },
  components: (formData) => {
    const structureComponents = formData.components || [];
    const salaryComponents = Object.values(structureComponents);
    if (!salaryComponents.length) {
      return 'Components are required';
    }

    return null;
  },
};
